<template>
    <div class="container-fluid">
        <div class="row button-placeholder">
            <div class="col-lg-2">
                <div :id="'dt-length-' + getDtId()" class="pull-left"></div>
                <form-export
                    :active="this.config && this.config.isDumpActionActive"
                    :action="$http.options.root + '/' + this.dumpUrl"
                    :filters="this.filters"
                    :default-filter="defaultFilter"
                ></form-export>
            </div>
        </div>
        <div class="bg price-analysis-dt">
            <data-table
                    :length-handle="'#dt-length-' + getDtId()"
                    :dt-id="'data-table-' + getDtId()"
                    :page-length="10"
                    :my-ajax="dataTableAjax"
                    :columns="columns"
                    :column-defs="columnDefs"
                    :refresh="DTRefresh"
                    :sort="false"
            ></data-table>
            <div class="clearfix"></div>
        </div>
    </div>
</template>

<script>
    import DataTable from "../../components/DataTable.vue";
    import FormExport from "../../components/FormExport.vue";

    export default
    {
        components: {DataTable, FormExport},
        props: {
            forwardedFilters: {
                type: Array,
                default: () => {
                    return [];
                },
            },
            shop: {
                type: String,
                default: null,
            },
            category: {
                type: String,
                default: null
            },
            priceType: {
                type: String,
                default: null
            },
            initUrl: {
                type: String,
                required: true,
            },
            dtUrl: {
                type: String,
                required: true,
            },
            dumpUrl: {
                type: String,
                required: true,
            }
        },
        data()
        {
            return {
                priceType: null,
                gap: null,
                columns: [],
                columnDefs: [],
                filters: [],
                DTRefresh: false,
                defaultFilter: {
                    search: '',
                    pagination: 50,
                },
                config: {
                    filterShow: false,
                },
            };
        },
        mounted()
        {
            this.init();
        },
        computed: {
        },
        methods:
        {
            init()
            {
                let data = {};

                if (this.shop) {
                    data.shops = [this.shop];
                }

                this.$http.get(this.initUrl, {params: data}).then(response => {
                    this.columns = response.body.columns;
                    this.columnDefs = this.buildColumnDefs();
                    this.filters = response.body.filters;
                    this.forwardFilters();
                    this.DTRefresh = !this.DTRefresh;
                });
            },
            getDtId()
            {
                return (this.category ? this.category : this.customCategory) + '-' + (this.shop ? '-' + this.shop : '');
            },
            dataTableAjax(data, callback)
            {
                delete data.columns;
                this.$buildFilters(this.filters, data);

                this.$http.get(this.dtUrl, {params: data}).then((response) => {
                    this.searchValue = response.body.searchValue;
                    callback(response.body)
                })
            },
            buildColumnDefs: function() {
                let _this = this;
                let boolColumnIndex = [];
                let t = this.$translate;
                let priceColumnIndex = [];
                _this.columns.forEach(function(column, index) {
                    if (column.type === 'boolean') {
                        boolColumnIndex.push(index);
                    }
                    if (column.data.includes('p_com_price_')) {
                        priceColumnIndex.push(index);
                    }
                });

                return [
                {
                    render: function (data, type, row, settings) {
                        return '<a href="' + row['p_own_product_link'] + '" target="_blank" rel="noreferrer">' + data + '</a>';
                    },
                    targets: 0
                },{
                    render: function (data, type, row, settings) {
                        return '<span>' + data + '</span><a href="/price-history/' + row['p_own_product_id'] + '" target="_blank">' +
                            '<span class="glyphicon glyphicon-stats pull-right" title="' + t.text('Details in new window') + '"></span></a>';
                    },
                    targets: 1
                },{
                    render: function (data, type, row, settings) {
                        if (data) {
                            return _this.$translate.text('Yes');
                        } else if (false === data) {
                            return _this.$translate.text('No');
                        }

                        return data ? data : '';
                    },
                    targets: boolColumnIndex
                },{
                    render: function (data, type, row, settings) {
                        let res = data;
                        let reg = new RegExp("^" + row['min_price']);
                        if (reg.test(data)) {
                            res = '<span class="min-price">' + data + '</span>';
                        }
                        let columnData = _this.columns[settings.col].data;
                        let split = columnData.split('_');
                        let shopId = split[split.length-1];
                        let link = row['p_com_product_link_' + shopId];
                        if (columnData === 'p_com_price_' + shopId && link) {
                            res = '<a href="' + link + '" target="_blank" rel="noreferrer">' + res + '</a>';
                        }

                        if (columnData.includes('price') && row['gap_' + shopId]) {
                            res = '<div class="gap-placeholder">' + res + '</div>';
                        }

                        return res ? res : '';
                    },
                    targets: priceColumnIndex
                },{
                    render: function(data, type, row) {
                        return '<b>' + data + '</b>';
                    },
                    targets: [1]
                }];
            },
            onClickEvent: function (id, row, e) {
                let tr = $(e.target).closest('tr');
                let icon = tr.find('.row-details .glyphicon');
                let productId = tr.find('.row-details').attr('data-product-id');
                if (row.child.isShown()) {
                    row.child.hide();
                    icon.addClass('glyphicon-chevron-down');
                    icon.removeClass('glyphicon-chevron-up')
                } else {
                    row.child(() => {
                        return '<div class="loading-fragment"><div class="dataTables_processing panel panel-default">'+this.$translate.text('Processing')+'...</div></div>';
                    }).show();
                    // new HistoryLoader({$route: {name: 'price-history'}, data: {productId: productId}}).$mount($(row.child()[0]).find('div')[0]);
                    window.location.href = 'price-history/' + productId;
                }
            },
            forwardFilters: function() {
                let _this = this;
                this.filters.forEach((f) => {
                    switch (f.name) {
                        case 'shops':
                            if (_this.shop) {
                                let res = f.availableValue.filter(function(v) {
                                    return v.id === parseInt(_this.shop);
                                });
                                if (res.length > 0) {
                                    f.value = f.value.concat(res);
                                }
                            }
                            break;
                        case 'categories':
                            if (_this.category) {
                                let res = f.availableValue.filter(function(v) {
                                    return v.id === parseInt(_this.category);
                                });
                                if (res.length > 0) {
                                    f.value = f.value.concat(res);
                                }
                            }
                            break;
                        case 'priceType':
                            if (_this.priceType) {
                                let res = f.availableValue.filter(function(v) {
                                    return v.value === _this.priceType;
                                });
                                if (res.length > 0) {
                                    f.value = _this.priceType;
                                }
                            }
                            break;
                        default:
                            let forwardedFilter = _this.$getFilterByName(_this.forwardedFilters, f.name);
                            if (forwardedFilter) {
                                f.value = forwardedFilter.value;
                            }
                    }
                });
            }
        }
    }
</script>


<style lang="sass">
    .button-placeholder {
        padding-top: 3px;
    }
    .min-price {
        color: darkred;
    }
    div.price-analysis-dt table > tbody > tr, div.price-analysis-dt table > thead > tr {
        font-size: 90%;
    }
    .gap-placeholder {
        text-decoration: underline;
        background-color: #e6ad9f;
        display: inline-block;
        white-space: nowrap;
    }

</style>


// WEBPACK FOOTER //
// detail.vue?0ea6d736